import { Cross2Icon } from '@radix-ui/react-icons';
import { Button, Dialog } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

export const ModalNoCard: React.FC<{ open: boolean; setOpen: (b: boolean) => void; text: string }> = ({
  open,
  setOpen,
  text,
}) => {
  const navigate = useNavigate();
  return (
    <Dialog.Root open={open}>
      <Dialog.Content maxWidth='450px'>
        <div className='flex w-full justify-between align-middle'>
          <Dialog.Title>Inserisci la tessera FITP</Dialog.Title>
          <Dialog.Close className='mb-4 cursor-pointer' onClick={() => setOpen(false)}>
            <Cross2Icon height={'24'} width={'24'} />
          </Dialog.Close>
        </div>
        <Dialog.Description className='hidden'>Scopri la classifica armonizzata del giocatore</Dialog.Description>

        <div className='flex flex-1 flex-row flex-wrap items-center justify-center gap-4'>
          {text}, devi inserire il numero di tessera FITP nel tuo profilo.
          <Button className='mt-10' onClick={() => navigate('/profilo/modifica')}>
            Inseriscilo da qui
          </Button>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default ModalNoCard;
